import LoadableImage from "../LoadableImage";
import Navigation from "../Navigation";
import BackLink from "../BackLink";
import ForwardLink from "../ForwardLink";
import {useEffect} from "react";

function Page32() {
  useEffect(() => {
    document.title = "Маяк — Страница 31"
  }, []);

  return (
    <>
      <Navigation />

      <div className="NavigationLink-wrapper">
        <BackLink href="/page30" />
        <ForwardLink href="/page32" />
      </div>

      <p style={{ textAlign: "right" }}>31.</p>
      <p style={{ textAlign: "center" }}>
        МОЛОДОЙ<br/>
        Дасэр.
      </p>
      <p style={{ textAlign: "center" }}>
        СТАРИК<br/>
        Не могу сказать, что осуждаю тебя. Я слышал рассказы<br/>
        о той жизни. Тяжелая жизнь.<br/>
        Говорят, один человек работает за двух<br/>
        лошадей. Нет, спасибо. Море, — единственное,<br/>
        что меня интересует.
      </p>
      <p style={{ textAlign: "center" }}>
        МОЛОДОЙ<br/>
        Скучаете по нему?
      </p>
      <p style={{ textAlign: "center" }}>
        СТАРИК<br/>
        Скучаю по нему? Я никогда не знал<br/>
        ничего, кроме этого.
      </p>
      <p style={{ textAlign: "center" }}>
        МОЛОДОЙ<br/>
        Мореплаванию.
      </p>
      <p style={{ textAlign: "center" }}>
        СТАРИК<br/>
        Ах... Да. Да.
      </p>
      <p>
        СТАРИК ясно видит морскую жизнь своими глазами. Истории,<br/>
        которые у него должны быть.
      </p>
      <p style={{ textAlign: "center" }}>
        СТАРИК (ПРОДОЛЖЕНИЕ)<br/>
        Нет ничего, что могло бы с этим сравниться.
      </p>
      <p>Он отвлекается от этого:</p>
      <p style={{ textAlign: "center" }}>
        СТАРИК (ПРОДОЛЖЕНИЕ)<br/>
        Но я не могу тащить свой старый<br/>
        обрубок...
      </p>
      <p style={{ textAlign: "center" }}>
        (Ссылаясь на свою хромоту)<br/>
        Нет... не стоит заморачиваться... теперь<br/>
        я викки и викки это я. Я<br/>
        чертовски предан этому<br/>
        маяку, и он был более прекрасной,<br/>
        более верной и тихой женой, чем любая<br/>
        женщина из крови и плоти.
      </p>
      <p style={{ textAlign: "center" }}>
        МОЛОДОЙ<br/>
        Когда-нибудь были женаты?
      </p>
      <p style={{ textAlign: "center" }}>
        СТАРИК<br/>
        Тринадцать рождеств в море...<br/>
        маленькие дети дома. Она так<br/>
        и не простила.
      </p>
      <p>Пауза.</p>
      <p style={{ textAlign: "center" }}>(ДАЛЕЕ)</p>
      <p style={{ textAlign: "right" }}>31.</p>
      
      <Navigation />
      
      <div className="NavigationLink-wrapper">
        <BackLink href="/page30" />
        <ForwardLink href="/page32" />
      </div>

      <LoadableImage
        src="https://res.cloudinary.com/linuxmachinecloud/image/upload/v1710020164/the-lighthouse-script/wob3jtzjudxctakxhavu.jpg"
        alt="Иллюстрация"
      />
    </>
  );
}

export default Page32;
